import { Component, Inject, OnInit } from '@angular/core';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { TableOption } from '../../../components/kiene-table/table-option';
import { NumberTableColumn, TableColumn, TextTableColumn } from '../../../components/kiene-table/table-column';

@Component({
    selector: 'kiene-abgelaufene-chargen',
    templateUrl: './abgelaufene-chargen.component.html',
    styleUrls: ['./abgelaufene-chargen.component.scss'],
})
export class AbgelaufeneChargenComponent implements OnInit {
    tableDescriptor = new TableDescriptor();

    constructor(@Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string) {}

    ngOnInit(): void {
        this.initTable();
    }

    private initTable() {
        this.tableDescriptor.headline = 'Abgelaufene Chargen';
        this.tableDescriptor.uniqueIdentifier = 'Abgelaufene Chargen';
        this.tableDescriptor.alternativeApiUrl = this.apiBaseUrl + 'charge/read_abgelaufen.php';
        this.tableDescriptor.initialSortColumn = 'artikel';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.permissionView = 4441;
        this.tableDescriptor.permissionCreate = 4442;

        this.tableDescriptor.createAllowed = false;

        this.tableDescriptor.columns = this.getTableColumns();

        this.tableDescriptor.options = this.getTableOptions();
    }

    private getTableColumns() {
        const columns: TableColumn[] = [];

        columns.push(new TextTableColumn('artikel_me', 'Artikel'));
        columns.push(new TextTableColumn('charge', 'Charge'));
        columns.push(new TextTableColumn('mhd', 'MHD'));
        columns.push(new NumberTableColumn('menge', 'Menge', '1.0-2'));
        columns.push(new TextTableColumn('lagerplatz', 'Lagerplatz'));

        return columns;
    }

    private getTableOptions() {
        const options: TableOption[] = [];

        return options;
    }
}
